/* KidoBook theme chrome behaviour: mega menu, predictive
   search, mobile drawer, footer accordion, carousels, countdown.
   All guarded so it can run once even if included more than once. */
(function () {
  'use strict';
  if (window.__ktThemeBooted) return;
  window.__ktThemeBooted = true;

  var doc = document;
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Mega menu (All categories) ---------- */
  function initMega() {
    doc.querySelectorAll('[data-kt-mega-toggle]').forEach(function (btn) {
      if (btn.dataset.ktMegaReady) return;
      btn.dataset.ktMegaReady = '1';
      var mega = doc.querySelector('[data-kt-mega]');
      if (!mega) return;
      var close = function () { mega.classList.add('kt-hidden'); btn.setAttribute('aria-expanded', 'false'); };
      var open = function () { mega.classList.remove('kt-hidden'); btn.setAttribute('aria-expanded', 'true'); };
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        mega.classList.contains('kt-hidden') ? open() : close();
      });
      doc.addEventListener('click', function (e) {
        if (!mega.contains(e.target) && e.target !== btn) close();
      });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      // Left-rail hover/click switches the visible column panel.
      mega.querySelectorAll('[data-kt-rail]').forEach(function (rail) {
        var activate = function () {
          mega.querySelectorAll('[data-kt-rail]').forEach(function (r) { r.classList.remove('is-active'); });
          mega.querySelectorAll('[data-kt-panel]').forEach(function (p) { p.classList.remove('is-active'); });
          rail.classList.add('is-active');
          var panel = mega.querySelector('[data-kt-panel="' + rail.getAttribute('data-kt-rail') + '"]');
          if (panel) panel.classList.add('is-active');
        };
        rail.addEventListener('mouseenter', activate);
        rail.addEventListener('focus', activate);
        rail.addEventListener('click', activate);
      });
    });
  }

  /* ---------- Predictive search (Shopify suggest API) ---------- */
 function money(amount) {
  var value = Number(amount);
  var currency =
    (window.Shopify &&
     Shopify.currency &&
     Shopify.currency.active) || 'USD';

  if (!Number.isFinite(value)) return '';

  try {
    return value.toLocaleString(undefined, {
      style: 'currency',
      currency: currency
    });
  } catch (e) {
    return value.toFixed(2) + ' ' + currency;
  }
}
  function initPredict() {
    doc.querySelectorAll('[data-kt-search]').forEach(function (wrap) {
      if (wrap.dataset.ktPredictReady) return;
      wrap.dataset.ktPredictReady = '1';
      var input = wrap.querySelector('input[type="search"], input[name="q"]');
      var box = wrap.querySelector('[data-kt-predict]');
      if (!input || !box) return;
      var timer, lastQ = '';
      var hide = function () { box.classList.add('kt-hidden'); };
      var run = function () {
        var q = input.value.trim();
        if (q === lastQ) return;
        lastQ = q;
        if (q.length < 2) { hide(); return; }
        var url = routeRoot + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=5&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) { render(data, q); })
          .catch(hide);
      };
      var render = function (data, q) {
        var res = (data && data.resources && data.resources.results) || {};
        var html = '';
        if (res.queries && res.queries.length) {
          html += '<span class="kt-predict__label">Suggestions</span>';
          res.queries.forEach(function (item) {
            html += '<a class="kt-predict__q" href="' + item.url + '"><span aria-hidden="true">&#9906;</span>' + esc(item.text) + '</a>';
          });
        }
        if (res.products && res.products.length) {
          html += '<span class="kt-predict__label">Titles</span>';
          res.products.forEach(function (p) {
            var img = (p.featured_image && p.featured_image.url) ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<span class="ph"></span>';
            var price = (typeof p.price !== 'undefined') ? '<span class="kt-predict__price">' + money(p.price) + '</span>' : '';
            html += '<a class="kt-predict__hit" href="' + p.url + '">' + img +
  '<span><b>' + esc(p.title) + '</b><small>' + price + '</small></span></a>';
          });
        }
        if (res.collections && res.collections.length) {
          html += '<span class="kt-predict__label">Collections</span>';
          res.collections.forEach(function (c) {
            html += '<a class="kt-predict__q" href="' + c.url + '">' + esc(c.title) + '</a>';
          });
        }
        if (!html) html = '<div class="kt-predict__empty">No matches for &ldquo;' + esc(q) + '&rdquo;.</div>';
        box.innerHTML = html;
        box.classList.remove('kt-hidden');
      };
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
      input.addEventListener('focus', function () { if (input.value.trim().length >= 2) run(); });
      doc.addEventListener('click', function (e) { if (!wrap.contains(e.target)) hide(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    });
  }
  function esc(s) { var d = doc.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = doc.querySelector('[data-kt-drawer]');
    if (!drawer || drawer.dataset.ktDrawerReady) return;
    drawer.dataset.ktDrawerReady = '1';
    var open = function () { drawer.classList.add('is-open'); doc.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('is-open'); doc.body.style.overflow = ''; };
    doc.querySelectorAll('[data-kt-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-kt-drawer-close], .kt-drawer__scrim').forEach(function (b) { b.addEventListener('click', close); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Footer accordion (mobile) ---------- */
  function initFooterAcc() {
    doc.querySelectorAll('[data-kt-foot-acc]').forEach(function (btn) {
      if (btn.dataset.ktFooterReady) return;
      btn.dataset.ktFooterReady = '1';
      btn.addEventListener('click', function () {
        var col = btn.closest('.kt-foot__col');
        if (col) col.classList.toggle('is-open');
      });
    });
  }

  /* ---------- Carousels (arrow scroll) ---------- */
  function initCarousels() {
    doc.querySelectorAll('[data-kt-carousel]').forEach(function (root) {
      if (root.dataset.ktCarouselReady) return;
      root.dataset.ktCarouselReady = '1';
      var rail = root.querySelector('[data-kt-rail-track]');
      if (!rail) return;
      root.querySelectorAll('[data-kt-prev]').forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); });
      });
      root.querySelectorAll('[data-kt-next]').forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); });
      });
    });
  }

  /* ---------- Countdown to a daily reset time ---------- */
  function initCountdown() {
    if (window.__ktCountdownTimer) return;
    if (!doc.querySelector('[data-kt-countdown]')) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      if (doc.hidden) return;
      doc.querySelectorAll('[data-kt-countdown]').forEach(function (el) {
        var hour = parseInt(el.getAttribute('data-reset-hour'), 10);
        if (isNaN(hour)) hour = 9;
        var now = new Date();
        var target = new Date(now);
        target.setHours(hour, 0, 0, 0);
        if (target <= now) target.setDate(target.getDate() + 1);
        var s = Math.floor((target - now) / 1000);
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      });
    };
    tick();
    window.__ktCountdownTimer = setInterval(tick, 1000);
  }

  /* ---------- Collection page: auto-submit and filter drawer ---------- */
  function initCollection() {
    // Auto-submit sort + facet forms on change.
    doc.querySelectorAll('[data-kt-autosubmit]').forEach(function (form) {
      if (form.__ktBound) return; form.__ktBound = true;
      form.addEventListener('change', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });
    // Mobile filter drawer.
    var facets = doc.querySelector('[data-kt-facets]');
    if (facets && !facets.dataset.ktFacetsReady) {
      facets.dataset.ktFacetsReady = '1';
      doc.querySelectorAll('[data-kt-facets-open]').forEach(function (b) { b.addEventListener('click', function () { facets.classList.add('is-open'); doc.body.style.overflow = 'hidden'; }); });
      doc.querySelectorAll('[data-kt-facets-close]').forEach(function (b) { b.addEventListener('click', function () { facets.classList.remove('is-open'); doc.body.style.overflow = ''; }); });
    }
  }

  function boot() {
    initMega(); initPredict(); initDrawer();
    initFooterAcc(); initCarousels(); initCountdown(); initCollection();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
  doc.addEventListener('shopify:section:load', boot);
})();
function formatSoldCounts() {
  document.querySelectorAll('[data-sold-count]').forEach(function(el) {
    var value = parseInt(el.dataset.soldCount, 10);

    if (!isNaN(value)) {
      el.textContent = value.toLocaleString('en-US') + ' sold';
    }
  });
}

document.addEventListener('DOMContentLoaded', formatSoldCounts);
formatSoldCounts();
function formatRatingCounts() {
  var locale = document.documentElement.lang || navigator.language || 'en-US';
  document.querySelectorAll('[data-rating-count]').forEach(function(el) {
    var raw = String(el.dataset.ratingCount || '').replace(/[^0-9-]/g, '');
    var value = parseInt(raw, 10);

    if (!isNaN(value)) {
      el.textContent = value.toLocaleString(locale);
    }
  });
}

document.addEventListener('DOMContentLoaded', formatRatingCounts);
document.addEventListener('shopify:section:load', formatRatingCounts);

formatRatingCounts();
